module.exports = __webpack_public_path__ + "static/media/HOW TO  INTEGRATE MAILCHIMP IN EZYMIGRATE AND USE IT IN DEALS.ae70149e.png";